<template>
    <Breadcrumbs main="Aspirateurs de site" mains="Aspirateurs de site" title="Paramètres" />
    <div class="container-fluid">
        <div class="row">
            <CrawlerList />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const CrawlerList = defineAsyncComponent(
    () => import('@/components/theme/crawler/CrawlerList.vue'),
);
</script>
